export default __webpack_public_path__ + "images/hand_baggage.df6051e.svg";